<template>
  <div class="maindr">
    <label v-for="item in data" :key="item.index">
      <el-menu-item :index="item.index" :key="item.index" @click="clickMenu(item)" v-if="item.children==undefined">
        <i :class="'el-icon-'+item.icon" class="_position"></i>
        <span slot="title">{{ item.label }}</span>
      </el-menu-item>

      <el-submenu :index="item.index" :key="item.index" v-if="item.children && item.children.length>0" @click="clickMenu(item)">
        <template #title class="el-menu-item">
          <i :class="'el-icon-'+item.icon" class="_position"></i>
          <span slot="title">{{ item.label }}</span>
        </template>
        <Drawing :data="item.children"></Drawing>
      </el-submenu>
    </label>

  </div>

</template>

<script>
export default {
  name: "Drawing",
  props: ["data"],
  data() {
    return {
      activeMenu: "",
    };
  },
  components: {},

  methods: {
    clickMenu(item) {
      this.$router.push({ path: item.path });
    },
  },
};
</script>
<style scoped>
>>> .maindr::-webkit-scrollbar {
  display: none;
}
.maindr {
  /* min-height: 863px; */
}
.el-menu-item {
  font-size: 18px;
  color: #303133;
  padding: 0 20px;
  cursor: pointer;
  -webkit-transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 20px;
  color: rgb(255, 255, 255);
  background-color: rgb(84, 92, 100);
  /* text-align: center; */
}
.el-menu-item span{
  margin-left: 20px;
}
>>> .el-submenu__title {
  font-size: 18px;
  /* text-align: center; */
}
>>> .el-submenu__title span{
  /* font-size: 20px; */
  /* text-align: center; */
  margin-left: 20px;
}
>>> .el-submenu__title i,
.el-menu-item i {
  float: left;
  line-height: 56px;
}
>>> .el-submenu__icon-arrow {
  top: 14%;
}
>>> .el-menu-item.is-active {
  color: #009589 !important;
  border-left: 5px solid #009589;
  border-bottom-color: #009589 !important;
}

.maindr .el-submenu .el-menu-item{
  /* min-height: 863px; */
  padding-left: 60px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/Components/SideBar/Drawing.vue